import { useState, useEffect, useFormContext, Code,  API, Utility,  Messages } from 'helpers/FormImports';
const SendNotification = () => {
  const {message, setMessage, showMenu, setShowMenu, confirm, setConfirm, error, setError, menuPosition, setMenuPosition, contextMenuRef, iframeRef, iframeRef2, formRef } = useFormContext();
  const companyName = Utility.Storage.CompanyName();

  const handleSendNotification = async () => {
    try {
      const companyId = Utility.Storage.CompanyId();
      
      const segmentId = Number(Code.Option.MessageSegment.APPOINTMENT); 
    
      //console.log("Sending Pickup Message with Company ID:", companyId, "Segment ID:", segmentId);

      if(companyId>0 && segmentId>0) {  
        const response = await API.Data.sendNotification(companyId, segmentId, setMessage );
        //console.log(response);
        if(response){
          Utility.Message.Info([`Appointment notification sent successfully`],setMessage);
        }
      }
      
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div style={{padding : "100px"}}>
      <Messages.Toast Messages={message} Error={error} />
      <div className='pb4'>Company : {companyName}</div>
      <button 
        type="button" 
        onClick={handleSendNotification} 
        className={`tbutton`} 
        >
        Click to Send Appointment Notification
      </button>
    </div>
  );
};

export default SendNotification;